import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const Ctx = createContext(null);

export const FlowProvider = ({ children }) => {
  const [pnc, setPnc] = useState('');
  const [visorId, setVisorId] = useState('');
  const [suffix, setSuffix] = useState('0');
  const [created, setCreated] = useState(false);
  const [finalVisorId, setFinalVisorId] = useState('');

  useEffect(() => {
    const saved = sessionStorage.getItem('android-install-flow');
    if (saved) {
      try {
        const s = JSON.parse(saved);
        setPnc(s.pnc ?? '');
        setVisorId(s.visorId ?? '');
        setSuffix(s.suffix ?? '0');
        setCreated(!!s.created);
        setFinalVisorId(s.finalVisorId ?? '');
      } catch {}
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem(
      'android-install-flow',
      JSON.stringify({ pnc, visorId, suffix, created, finalVisorId })
    );
  }, [pnc, visorId, suffix, created, finalVisorId]);

  const value = useMemo(
    () => ({ pnc, setPnc, visorId, setVisorId, suffix, setSuffix, created, setCreated, finalVisorId, setFinalVisorId }),
    [pnc, visorId, suffix, created, finalVisorId]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useFlow = () => {
  const v = useContext(Ctx);
  if (!v) throw new Error('useFlow must be used inside FlowProvider');
  return v;
};
